// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4bbc9580","455":"50cdb5a8"}[chunkId] + ".chunk.js";
};